<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>设备管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>设备列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>设备列表</span>
        </div>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item label="分类:">
            <el-select v-model="search.type" placeholder="请选择分类">
              <el-option v-for="item in devType" :key="item.id" :label="item.zh_name" :value="item.zh_name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="dev_id" label=" DID" width="130"></el-table-column>
          <el-table-column prop="devid" label="MID" width="120"></el-table-column>
          <el-table-column prop="aside_v" label="设备类型" width="120"></el-table-column>
          <el-table-column prop="company" label="品牌"></el-table-column>
          <el-table-column prop="is_online" label="联网状态" width="80">
            <template slot-scope="scope">
              <el-link v-if="scope.row.online == 1" type="success" :underline="false">在线</el-link>
              <el-link v-else type="danger" :underline="false">离线</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="central_v" label="【中控】当前版本" width="160"></el-table-column>
          <el-table-column label="可升级版本" width="120">
            <template slot-scope="scope">
              {{ scope.row.version_new }}
              <i v-if="scope.row.version_update == 1" class="el-icon-top text-price"></i>
            </template>
          </el-table-column>
          <el-table-column prop="version_time" label="版本上传时间" width="160"></el-table-column>
          <el-table-column prop="touch_v" label="【触控】当前版本" width="160"></el-table-column>
          <el-table-column prop="version_etime" label="最近更新时间" width="160"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(scope.row, 'auto')">自动升级</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row, 'update')">手动升级</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background layout="total,prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 手动升级 -->
    <el-dialog title="设备升级操作" width="30%" :visible.sync="dialogTableVisible">
      <el-form :model="modelForm" :rules="rules_model" ref="modelForm">
        <el-form-item label="设备：" prop="devid" label-width="120px">
          <el-input placeholder="请输入名称" disabled v-model="modelForm.devid"></el-input>
        </el-form-item>
        <el-form-item label="升级代码：" prop="cmds" label-width="120px">
          <el-input placeholder="请输入升级命令" v-model="modelForm.cmds"></el-input>
        </el-form-item>
        <el-form-item class="right">
          <el-button :loading="hand_loading" @click="save_model('modelForm')" icon="el-icon-search" type="primary">确认升级</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 自动升级 -->
    <el-dialog title="设备自动升级" width="30%" :visible.sync="dialogVersionVisible">
      <el-form :model="versionForm" :rules="rules_version" ref="versionForm">
        <el-form-item label="设备：" prop="devid" label-width="120px">
          <el-input placeholder="请输入名称" disabled v-model="versionForm.devid"></el-input>
        </el-form-item>
        <el-form-item label="选择版本：" prop="version_id" label-width="120px">
          <el-select v-model="versionForm.version_id" placeholder="请选择" style="width:100%;">
            <el-option v-for="item in versionData" :key="item.id" :label="item.nick + '(V'+item.version+')'" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="right">
          <el-button :loading="auto_loading" @click="auto_model('versionForm')" icon="el-icon-warning-outline" type="primary">确认升级</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hand_loading: false,
      auto_loading: false,
      dialogTableVisible: false,
      dialogVersionVisible: false,
      loading: true,
      tableData: [],
      versionData: [],
      page: 0,
      count: 0,
      limit: 10,
      search: {
        type: "",
        keys: "",
      },
      modelForm: {
        devid: "",
        cmds: "",
      },
      rules_model: {
        devid: [{ required: true, message: "请添加设备ID", trigger: "change" }],
        cmds: [
          { required: true, message: "请添加升级命令", trigger: "change" },
        ],
      },
      versionForm: {
        devid: "",
        version_id: "",
      },
      rules_version: {
        devid: [{ required: true, message: "请添加设备ID", trigger: "change" }],
        version_id: [
          { required: true, message: "请选择版本", trigger: "change" },
        ],
      },
      devType: [],
      timer: "",
      msg: "",
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
    that.getDevType();
  },
  methods: {
    getDevType() {
      let that = this;
      that.axios.post("/custom/getCate").then((res) => {
        if (res) {
          that.devType = res.data;
        }
      });
    },

    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(command) {
      console.log(command);
      switch (command.command) {
        case "update":
          if (command.row.online == 0) {
            this.$message("设备不在线，无法升级");
          } else {
            this.modelForm.devid = command.row.devid;
            this.dialogTableVisible = true;
          }
          break;
        case "auto":
          if (command.row.online == 0) {
            this.$message("设备不在线，无法升级");
          } else {
            console.log(command.row.version_id);
            this.versionForm.devid = command.row.devid;
            this.getVersions(command.row.aside_v);
            this.versionForm.version_id = command.row.version_id;
            this.dialogVersionVisible = true;
          }
          break;
      }
    },
    auto_model(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.versionForm;
        var url = "/dev/auto_update";
        that.axios.post(url, formData).then((res) => {
          that.auto_loading = true;
          if (res.code == 200) {
            that.msg = that.$message.warning({
              duration: 0,
              showClose: true,
              message: res.msg,
              onClose: function () {
                that.auto_loading = false;
                window.clearInterval(that.timer);
              },
            });
            that.timer = window.setInterval(() => {
              setTimeout(() => {
                that.getVersionStatus(res.data);
              }, 0);
            }, 3000);
          } else {
            that.$message.error(res.msg);
          }
        });
      });
    },
    save_model(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.modelForm;
        var url = "/dev/hand_update";
        that.axios.post(url, formData).then((res) => {
          that.auto_loading = true;
          if (res.code == 200) {
            that.msg = that.$message.warning({
              duration: 0,
              showClose: true,
              message: res.msg,
              onClose: function () {
                that.auto_loading = false;
                window.clearInterval(that.timer);
              },
            });
            that.timer = window.setInterval(() => {
              setTimeout(() => {
                that.getVersionStatus(res.data);
              }, 0);
            }, 3000);
          } else {
            that.$message.error(res.msg);
          }
        });
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.search.type = "";
      this.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      formData.type = that.search.type;
      that.axios.post("/dev/devinfo", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
    getVersions(aside_v) {
      let that = this;
      that.axios
        .post("/version/get_version", {
          aside_v: aside_v,
        })
        .then((res) => {
          if (res) {
            that.versionData = res.data;
          }
        });
    },
    getVersionStatus(ids) {
      let that = this;
      that.axios
        .post("/dev/check_update_success", {
          ids: ids,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.status == 1) {
              that.auto_loading = false;
              that.versionForm.dev_id = "";
              that.versionForm.version_id = "";
              window.clearInterval(that.timer);
              that.dialogTableVisible = false;
              that.dialogVersionVisible = false;
              that.msg.close();
              that.$message.success("升级成功");
            }
          }
        });
    },
  },
  destroyed() {
    window.clearInterval(this.timer);
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>